import store from 'store';

export interface SearchSessionValue {
  isShowableNotification: boolean;
  history: SearchHistory[];
  expiresAt: number;
  version: number;
}

export interface SearchHistory {
  query: string;
  area: string;
  condition: string;
  searchedAt: number;
}

export class SearchSession {

  static get = <K extends keyof SearchSessionValue>(key: K): SearchSessionValue[K] => {
    const v = store.get('search');
    if (SearchSession.isInvalidVersion(v)) {
      store.set('search', SearchSession.initValue);
    }
    return store.get('search')[key];
  }

  static set = <K extends keyof SearchSessionValue>(key: K, value: SearchSessionValue[K]): void => {
    const v = store.get('search');
    v[key] = value;
    store.set('search', v);
  }

  private static currentUnixTime: number = Math.floor(((new Date).getTime())) / 1000;

  private static initValue: SearchSessionValue = {
    isShowableNotification: true,
    history: [],
    expiresAt: SearchSession.currentUnixTime + (60 * 24 * 60 * 60),
    version: 1,
  }

  private static isInvalidVersion = (v: SearchSessionValue | undefined): boolean => {
    return v == undefined || v.expiresAt == undefined || v.expiresAt < SearchSession.currentUnixTime || v.version !== 1;
  }
}
